export default {"src":"/_next/static/media/whatsapp.5e96020c.svg","height":35,"width":35};